export enum ErrorType {
    ActivationError = "activate",
    DeactivationError = "deactivate",
    PlaceError = "place",
    StakeError = "stake",
    PurchaseError = "purchase",
    IncompatibleSelectionsError = "incompatibleSelections"
}